export enum TRASHED {
  TRASHED_ONLY = 'ONLY',

  TRASHED_WITH = 'WITH',

  TRASHED_WITHOUT = 'WITHOUT',
}
